import { AssetItemDto, AssetVersionItemDto } from '@api/Api';

export type ShapesDrawingToolsProps = {
  color: string;
  shape:
    | 'pin'
    | 'arrow'
    | 'rectangle'
    | 'line'
    | 'ellipse'
    | 'brush'
    | 'text'
    | 'documentHighlight';
  mode: 'edit' | 'draw';
};

export const MEDIA_VIEWER_ZOOM_OPTIONS = [
  'auto',
  'fit-width',
  'fit-height',
  'actual-size'
] as const;

export interface IMediaViewerState {
  assets: AssetItemDto | null;
  selectedVersion: AssetVersionItemDto | null;
  shapesDrawingTools: ShapesDrawingToolsProps;
  selectedCommentId: string | null;
  canvasMode: 'view' | 'edit';
  isSelectedCanvasObject: boolean;
  playerTime: (number | null)[];
  activePageNumber: number;
  zoomFactor: number;
  zoomOption?: (typeof MEDIA_VIEWER_ZOOM_OPTIONS)[number];
  turnoverDegree: number;
  commentText: string | null;
  isTimecodeChecked: boolean;
  isToolsExpanded: boolean;
  timeFormat: 'standard' | 'frames';
  isSourceSelected: boolean;
  isCommentFieldFocused: boolean;
  documentHighlight: {
    text: string;
    rects: { top: number; left: number; width: number; height: number }[];
  };
}

export interface IMediaViewerAction {
  type: string;
  payload?: any;
}

export enum MediaViewerActionTypes {
  SET_ASSET = 'SET_ASSET',
  TOGGLE_ASSET_FAVORITE = 'TOGGLE_ASSET_FAVORITE',
  RENAME_ASSET_VERSION = 'RENAME_ASSET_VERSION',
  SET_SELECTED_VERSION = 'SET_SELECTED_VERSION',
  UPDATE_SELECTED_VERSION = 'UPDATE_SELECTED_VERSION',

  SET_TOOLS_EXPANDED = 'SET_TOOLS_EXPANDED',
  SET_DRAW_TOOLS_COLOR = 'SET_DRAW_TOOLS_COLOR',
  SET_DRAW_TOOLS_SHAPE = 'SET_DRAW_TOOLS_SHAPE',
  SET_DRAW_TOOLS_MODE = 'SET_DRAW_TOOLS_MODE',

  SELECT_COMMENT = 'SELECT_COMMENT',
  SET_CANVAS_MODE = 'SET_CANVAS_MODE',
  SET_SELECTED_CANVAS_OBJECT = 'SET_SELECTED_CANVAS_OBJECT',
  SET_PLAYER_TIME = 'SET_PLAYER_TIME',
  SET_ACTIVE_PAGE_NUMBER = 'SET_ACTIVE_PAGE_NUMBER',
  SET_ZOOM_FACTOR = 'SET_ZOOM_FACTOR',
  SET_ZOOM_OPTION = 'SET_ZOOM_OPTION',
  SET_TURNOVER_DEGREE = 'SET_TURNOVER_DEGREE',
  SET_COMMENT_TEXT = 'SET_COMMENT_TEXT',
  SET_IS_TIMECODE_CHECKED = 'SET_IS_TIMECODE_CHECKED',
  SET_TIME_FORMAT = 'SET_TIME_FORMAT',
  SET_IS_SOURCE_SELECTED = 'SET_IS_SOURCE_SELECTED',
  SET_IS_COMMENT_FIELD_FOCUSED = 'SET_IS_COMMENT_FIELD_FOCUSED',

  SET_RESET_ASSET_STATE = 'SET_RESET_ASSET_STATE',
  SET_RESET_ASSET_VERSION_STATE = 'SET_RESET_ASSET_VERSION_STATE',

  SET_DOCUMENT_HIGHLIGHT = 'SET_DOCUMENT_HIGHLIGHT'
}
